import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import IconButton from "@material-ui/core/IconButton";
import { StyledButton, StyledMenu, StyledMenuItem } from "./styles";
import VerticalThreeDots from "assets/dashboardIcons/verticalThreeDots";
import { useHistory } from "react-router";
import { AlertPopup } from "components/alertPopup/alertPopup";
import axios from "axios";
import { API_HOST } from "constants.js";
import { AddDocsPendingIDPPopUp } from "components/addDocsPendingIDPPopUp";
import { EditAccountPopup } from "../../../../components/addAccountPopup/addAccountPopup";
import { useDispatch, useSelector } from "react-redux";
import { underwriterClientSelector } from "../../../../data/selectors/underwriters";
import { getUnderwriterClientInfo } from "../../../../data/actions/underwriters";
import { AddSubsidiaryAccountPopup } from "../../../../components/addAccountPopup/addSubAccountPopup";

export const ActionsMenu = ({
  client_id,
  institution_id,
  companyName,
  subsidiaries,
  status,
  userId,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  let history = useHistory();
  const [showPopup, setShowPopup] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 453 });
  const [openDocsPendingIDPPopup, setOpenDocsPendingIDPPopup] = useState(false);
  const [openEditAccountPopup, setOpenEditAccountPopup] = useState(false);
  const [openAddSubAccountPopup, setOpenAddSubAccountPopup] = useState(false);

  const [clientToEdit, setClientToEdit] = useState(null);

  const user = JSON.parse(localStorage.getItem("User"));
  const isAgentUnderwriter = user?.is_agent_to_access_esub_and_idp;

  const handleUploadPdfFile = async (file) => {
    let headers = {};
    const getAuth = () => {
      const authData = localStorage.getItem("Authorization");
      if (authData) {
        headers = { Authorization: authData };
      }
    };
    setShowPopup(true);

    if (file) {
      const formData = new FormData();
      formData.append("account_id", client_id);
      formData.append("company_name", companyName);
      formData.append("pdfFile", file);

      try {
        getAuth();
        const response = await axios.post(
          `${API_HOST}/underwriter/financial/data/analysis`,
          formData,
          {
            headers: {
              ...headers,
              "Content-Type": "multipart/form-data",
            },
          },
        );
        setShowPopup(false);
      } catch (error) {
        setShowPopup(false);
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const seeAllProjects = () => {
    history.push("/underwriter/client/projects", {
      company_name: companyName,
      account_id: client_id,
      institutionId: institution_id,
      userId
    });
  };

  const viewFinancialAnalysis = () => {
    history.push("/underwriter/client/financialanalysis", {
      company_name: companyName,
      account_id: client_id,
      subsidiaries: subsidiaries,
      userId,
    });
  };

  const handleStartNewESub = () => {
    history.push("/prequalify/qualifying?e-sub=true", {
      accountId: client_id,
      institution_id,
      userId,
    });
  };

  const handleViewAllESub = () => {
    history.push("/all/CQS?e-sub=true", { companyName, institution_id, accountId: client_id });
  };

  const viewDocsPendingIDP = () => {
    setOpenDocsPendingIDPPopup(true);
  };

  const seeWorkInProgress = () => {
    history.push("/underwriter/client/wip", {
      company_name: companyName,
      account_id: client_id,
      institutionId: institution_id,
      userId
    });
  };

  const underwriterClientInfoData = useSelector(
    underwriterClientSelector,
    (prev, next) => prev.length === next.length,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (underwriterClientInfoData.length < 1) {
      dispatch(getUnderwriterClientInfo());
    }
  }, [underwriterClientInfoData]);

  const editAccount = () => {
    console.log("underwriterClientInfoData", underwriterClientInfoData);
    const matchedClient = underwriterClientInfoData.find(
      (client) => client.AccountId === client_id,
    );
    console.log("Matched Client: ", matchedClient);
    //
    // //     accountId: "",
    // //     companyName: "",
    // //     submissionDate: "",
    // //     accountType: "",
    // //     address: "",
    // //     uwOffice: "",
    // //     contractorType: "",
    // //     contractorGroup: "",
    // //     financialYeDate: "",
    // //     naicsCode: "",
    //
    setClientToEdit(matchedClient);
    setOpenEditAccountPopup(true);
  };

  const handleAddNewSubsidiary = () => {
    setOpenAddSubAccountPopup(true);
  };

  const goToIdp = () => {
    history.push("/underwriter/idpdocuments/uploader", {
      account_id: client_id,
      userId
    });
  };

  // {
  //   "AccountId": 4708675,
  //     "ClassifierThreshold": 90,
  //     "CompanyName": "Marmolejo Construction Co.",
  //     "Province": "Subcontractor",
  //     "SubsidiaryAddress": "",
  //     "SubsidiaryName": "",
  //     "count": 0,
  //     "facount": 0,
  //     "idp_doc_count": 2,
  //     "insightAvailable": [
  //   "PrD ",
  //   "PGA ",
  //   "RiS "
  // ],
  //     "whoAccess": null
  // }

  if (["deleted"].includes(status)) {
    return <></>;
  } else {
    return (
      <>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
          style={{ padding: 0 }}
        >
          <VerticalThreeDots />
        </IconButton>
        <StyledMenu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          {/* <StyledMenuItem>
            <StyledButton width="180px">
              Upload Docs
              <input
                id="file-input"
                type="file"
                accept="application/pdf"
                style={{
                  position: "absolute",
                  opacity: 0,
                }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleUploadPdfFile(file);
                  }
                }}
              />
            </StyledButton>
          </StyledMenuItem> */}

          <StyledMenuItem>
            <StyledButton width="180px" onClick={viewFinancialAnalysis}>
              Financial Analysis
            </StyledButton>
          </StyledMenuItem>

          {/* <StyledMenuItem>
            <StyledButton width="180px" onClick={viewDocsPendingIDP}>
              Docs Pending IDP*
            </StyledButton>
          </StyledMenuItem> */}

          <StyledMenuItem>
            <StyledButton
              width="180px"
              onClick={seeWorkInProgress}
              // disabled
            >
              WIP Analysis
            </StyledButton>
          </StyledMenuItem>

          <StyledMenuItem>
            <StyledButton width="180px" onClick={seeAllProjects}>
              All Projects
            </StyledButton>
          </StyledMenuItem>

          <StyledMenuItem>
            <StyledButton width="180px" disabled>
              pledgXeCQS
            </StyledButton>
          </StyledMenuItem>

          <StyledMenuItem>
            <StyledButton
              width="180px"
              onClick={() => console.log("future implementation")}
              disabled
            >
              References
            </StyledButton>
          </StyledMenuItem>
          <StyledMenuItem>
            <StyledButton
              width="180px"
              onClick={editAccount}
              disabled={isAgentUnderwriter}
              // disabled
            >
              Edit Account
            </StyledButton>
          </StyledMenuItem>
          <StyledMenuItem>
            <StyledButton
              width="180px"
              onClick={handleAddNewSubsidiary}
              // disabled
            >
              Add New Subsidiary
            </StyledButton>
          </StyledMenuItem>
          {isAgentUnderwriter && (
            <>
               <StyledMenuItem>
                <StyledButton width="180px" onClick={goToIdp}>
                  IDP Upload
                </StyledButton>
              </StyledMenuItem>
              <StyledMenuItem>
                <StyledButton
                  width="180px"
                  onClick={handleStartNewESub}
                  // disabled
                >
                  Start New eSUB
                </StyledButton>
              </StyledMenuItem>
              <StyledMenuItem>
                <StyledButton
                  width="180px"
                  onClick={handleViewAllESub}
                  // disabled
                >
                  View eSUB
                </StyledButton>
              </StyledMenuItem>
            </>
          )}
          {/*<StyledMenuItem>
            <StyledButton width="180px" onClick={seeWorkInProgress}>
              WIP
            </StyledButton>
          </StyledMenuItem> */}
        </StyledMenu>
        <EditAccountPopup
          open={openEditAccountPopup}
          setOpen={setOpenEditAccountPopup}
          client={clientToEdit}
        />

        <AddSubsidiaryAccountPopup
          open={openAddSubAccountPopup}
          setOpen={setOpenAddSubAccountPopup}
          accountId={client_id}
          companyName={companyName}
          userId={userId}
        />

        <AddDocsPendingIDPPopUp
          setOpenDialog={setOpenDocsPendingIDPPopup}
          openDialog={openDocsPendingIDPPopup}
        />

        <AlertPopup
          openPopup={showPopup}
          setOpenPopup={setShowPopup}
          isMobile={isMobile}
          headerText="File Uploaded Successfully."
          subHeaderText={
            <>
              IDP In Progress...
              <span style={{ animation: "spin 2s linear infinite" }}>
                ⏳
              </span>{" "}
              <br />
              Approximate time for completion: 5-10 minutes{" "}
            </>
          }
          showButton={false}
        />
      </>
    );
  }
};
